const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export const emptyTeamMemberForm = {
  nom: "",
  prenom: "",
  fonction: "",
  photoURL: "",
  position: 1,
};

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.members)) return data.members;
    if (Array.isArray(data.teamMembers)) return data.teamMembers;
    if (Array.isArray(data.data)) return data.data;
  }

  return [];
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function isExternalURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = "/images/user_avatar.jpg") {
  if (!url) return fallback;

  const value = String(url).trim();

  if (
    isExternalURL(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${API_BASE}${value}`;
  }

  return value;
}

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getMemberFullName(member) {
  return `${member?.prenom || ""} ${member?.nom || ""}`.trim() || "Responsable";
}

export function getStats(teamMembers) {
  const fonctions = new Set(
    teamMembers
      .map((member) => String(member.fonction || "").trim())
      .filter(Boolean)
  );

  return {
    total: teamMembers.length,
    withPhoto: teamMembers.filter((member) =>
      String(member.photoURL || "").trim()
    ).length,
    fonctions: fonctions.size,
    ordered: teamMembers.filter(
      (member) =>
        member.position !== null &&
        member.position !== undefined &&
        String(member.position).trim() !== ""
    ).length,
  };
}

export function mapTeamMemberToForm(member = {}) {
  return {
    nom: member.nom || "",
    prenom: member.prenom || "",
    fonction: member.fonction || "",
    photoURL: member.photoURL || "",
    position: member.position ?? 1,
  };
}

export function buildTeamMemberPayload(formData) {
  return {
    nom: formData.nom,
    prenom: formData.prenom,
    fonction: formData.fonction,
    photoURL: formData.photoURL,
    position: Number(formData.position || 1),
  };
}